module.exports = __webpack_public_path__ + "img/tramite1.67079c1c.svg";